interface IconProps {
  color?: string
  className?: string
}

export default function ArrayDownIcon({ color: _color, className }: IconProps) {
  return (
    <svg
      width="14"
      height="15"
      viewBox="0 0 14 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M12.8125 5.96875L13.5 6.65625C13.7812 6.96875 13.7812 7.4375 13.5 7.71875L7.4375 13.7812C7.125 14.0938 6.65625 14.0938 6.375 13.7812L0.28125 7.71875C0 7.4375 0 6.9375 0.28125 6.65625L0.96875 5.96875C1.28125 5.65625 1.75 5.6875 2.0625 5.96875L5.65625 9.75V0.75C5.65625 0.34375 5.96875 0 6.40625 0H7.40625C7.8125 0 8.15625 0.34375 8.15625 0.75V9.75L11.7188 5.96875C12.0312 5.6875 12.5 5.65625 12.8125 5.96875Z"
        fill="#CCFF00"
      />
    </svg>
  )
}
